import React, { useState, useEffect } from "react";
import { Container, Typography, IconButton, Avatar, AppBar, Toolbar } from "@mui/material";
import { auth, uploadImage, updateUserProfile } from "../firebase";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { isLoggedIn } from "../session";
import { useNavigate } from "react-router-dom";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import CircularProgress from "@mui/material/CircularProgress";
import Atras from "./atras";

function Header() {

  const [displayName, setDisplayName] = useState("");
  const [email, setEmail] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [uid, setUid] = useState("");
  const [loading, setLoading] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const { uid } = user;
          const db = getFirestore();
          const userDocRef = doc(db, "users", uid);

          const userDocSnapshot = await getDoc(userDocRef);

          if (userDocSnapshot.exists()) {
            const userData = userDocSnapshot.data();
            const userName = userData.displayName || "Usuario";
            const userEmail = userData.email || "";
            const uid = userData.uid || "";
            setEmail(userEmail);
            setDisplayName(userName, userEmail);
            setUid(uid);
            if (userData.profileImageUrl) {
              setProfileImageUrl(userData.profileImageUrl);
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        // Si el usuario cierra sesión, podemos limpiar el estado del displayName y de la imagen de perfil
        setDisplayName("");
        setEmail("");
        setProfileImageUrl(null);
      }
    });

    return unsubscribe;
  }, []);

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    try {
      // Activar el indicador de progreso
      setLoading(true);

      // Subir la imagen al almacenamiento y obtener la URL de descarga
      const imageUrl = await uploadImage(file);

      // Obtener el usuario actual
      const user = auth.currentUser;
      if (user) {
        const uid = user.uid;

        // Actualizar la URL de la imagen de perfil en la base de datos
        await updateUserProfile(uid, { profileImageUrl: imageUrl });

        // Actualizar el estado con la nueva URL de la imagen de perfil
        setProfileImageUrl(imageUrl);
      }

      // Desactivar el indicador de progreso después de completar la carga
      setLoading(false);
    } catch (error) {
      console.error("Error uploading image:", error);
      // En caso de error, desactivar el indicador de progreso
      setLoading(false);
    }
  };

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  const styles = {
    media: {
      marginLeft: "auto",
      marginRight: "auto",
      width: "70px",
      height: "auto",
      marginTop: "3px",
      marginBottom: "3px",
      position: "relative",
      left: -20
    },
  };
  return (
    <AppBar position="fixed">
      <Toolbar sx={{padding: "7px"}}>
        <Atras />
        {profileImageUrl && (
            <Avatar
              sx={{
                marginLeft: 2,
                padding: "0px",
                border: "2.5px solid white",
              }}
              alt="Perfil"
              src={profileImageUrl}
              style={styles.avatar}
            />
          )}
          <div style={{ position: "relative" }}>
            <input
              type="file"
              accept="image/*"
              onClick={(event) => (event.target.value = null)}
              onChange={handleImageUpload}
              style={{ display: "none" }}
              id="upload-button"
            />
            <IconButton
              variant="contained"
              component="span"
              sx={styles.uploadButton}
              onClick={() => document.getElementById("upload-button").click()}
              color="black"
            >
              <AddPhotoAlternateIcon />
              {loading && (
                <CircularProgress
                  size={40}
                  thickness={4}
                  sx={{color: "white", position: "relative", left: "-30px"}}
                />
              )}
            </IconButton>
          </div>
          <Container style={styles.user}>
            <Typography variant="h5" color="white">
              {displayName}
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontSize: "12px", color: "white" }}
              gutterBottom
            >
              {email}
            </Typography>
          </Container>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
